function detectApiBaseUrl(): string {
  const fromEnv = import.meta.env.VITE_API_URL as string | undefined;
  if (fromEnv) return fromEnv;
  if (typeof window === 'undefined') return 'http://localhost:4000';
  const { pathname, origin } = window.location;
  if (pathname === '/admin-app' || pathname.startsWith('/admin-app/')) return origin;
  return 'http://localhost:4000';
}

export const apiBaseUrl = detectApiBaseUrl();
